import TABLE_DATA_KEYS from '@/components/base_components/tables/enum/table-data-keys';
import { mapActions, mapGetters } from 'vuex';
import i18n from "@/language/i18n";

import { dynamicParameter } from '@/mixins/service/mixin-service';

const DEFAULT_ATTRIBUTES = Object.freeze([
  { text: i18n.t('Common.and'), value: 'and' },
  { text: i18n.t('Common.or'), value: 'or' }
]);

const DEFAULT_RELATION = () => 'attributeRelation'

export default function(
  name,
  relation = DEFAULT_RELATION,
  filterOptions = DEFAULT_ATTRIBUTES,
  filters = undefined
) {
  const getFilters = dynamicParameter(filters);
  const getRelation = dynamicParameter(relation);
  const getName = dynamicParameter(name);

  return {
    computed: {
      ...mapGetters('tableStore', ['getTable']),
      filterOptions() {
        return filterOptions;
      },
      filterOptionValue() {
        return this._getFilter(getRelation(this)) ?? '';
      },
      moreThanOneAttributesSelected() {
        const currentAttributes = this._getFilter(getName(this));
        return currentAttributes?.length > 1;
      }
    },
    methods: {
      ...mapActions('tableStore', ['setFilterValue']),
      _getFilter(filterId) {
        if (!getFilters(this)) {
          let table = this.getTable(this.$route);
          return table?.[TABLE_DATA_KEYS.FILTERS]?.[filterId];
        }
        return getFilters(this)?.[filterId];
      }
    },
    watch: {
      moreThanOneAttributesSelected(newValue) {
        if (newValue === true && !getFilters(this) && !this.filterOptionValue) {
          this.setFilterValue({
            key: getRelation(this),
            value: 'and',
            $route: this.$route
          });
        } else {
          if (getFilters(this)) getFilters(this)[getRelation(this)] = 'and';
        }
      }
    }
  };
}
